<template>
  <div class="view timelog">

  <box>

    <div class="grid">
      <div class="col m20">

        <inputfield label="Bruger" v-if="false">
          <select v-model="filter_user_key" class="select-styled">
            <option value="undefined">Alle</option>
            <option :value="user['.key']" v-for="(user, i) in users">
              <template v-if="user && user.first_name">{{user.first_name}}</template>
            </option>
          </select>
          <div class="select-arrow">▾</div>
          
        </inputfield>

        <multiselect
          :options="userSelectOptions"
          :value="multiSelectGetOption(userSelectOptions,'value',filter_user_key)"
          @select="multiSelectOnSelect('filter_user_key',$event)"
          placeholder="Vælg..." label="label" track-by="value" select-label="" selected-label="" deselect-label="" :reset-after="false"
        />

      </div>
      <div class="col m20">

        <inputfield label="Kunde" v-if="false">
          <select v-model="filter_client_key">
            <option value="undefined">Alle</option>
            <option :value="client['.key']" v-for="(client, i) in clients">
              {{client.name}}
            </option>
          </select>
          <div class="select-arrow">▾</div>          
        </inputfield>

        <multiselect
          :options="clientSelectOptions"
          :value="multiSelectGetOption(clientSelectOptions,'value',filter_client_key)"
          @select="multiSelectOnSelect('filter_client_key',$event)"
          placeholder="Vælg..." label="label" track-by="value" select-label="" selected-label="" deselect-label="" :reset-after="false"
        />

      </div>
      <div class="col m20">

        <inputfield label="Opgave" v-if="false">
          <select v-model="filter_project_key">
            <option value="undefined">Alle</option>
            <option :value="project['.key']" v-for="(project, i) in projects" v-if="( !filter_client_key || filter_client_key == 'undefined' ) || filter_client_key == project.client_key">
              {{project.name}} - ({{getOne('client',project.client_key).name}})
            </option>
          </select>
          <div class="select-arrow">▾</div>
        </inputfield>

        <multiselect
          :options="projectSelectOptions"
          :value="multiSelectGetOption(projectSelectOptions,'value',filter_project_key)"
          @select="multiSelectOnSelect('filter_project_key',$event)"
          placeholder="Vælg..." label="label" track-by="value" select-label="" selected-label="" deselect-label="" :reset-after="false"
        />

      </div>
      <div class="col m20">

        <inputfield :label="'Fra: '+dateFormat(filter_date_from,'ddd DD/MM')">
          <input type="date" v-model="filter_date_from" @focus="blockFilterUpdates = true" @blur="blockFilterUpdates = false" @click.enter="blockFilterUpdates = false">
        </inputfield>

      </div>
      <div class="col m20">

        <inputfield :label="'Til: '+dateFormat(filter_date_to,'ddd DD/MM')">
          <input type="date" v-model="filter_date_to" @focus="blockFilterUpdates = true" @blur="blockFilterUpdates = false" @click.enter="blockFilterUpdates = false">
        </inputfield>

      </div>
    </div>

    <br>

    <btn @click.native="setTimeframe('one-day-back')">&mdash;</btn>
    <btn @click.native="setTimeframe('today')">I dag</btn>
    <btn @click.native="setTimeframe('one-day-forward')">+</btn>
    &nbsp;&nbsp;&nbsp;
    <btn @click.native="setTimeframe('one-month-back')">&mdash;</btn>
    <btn @click.native="setTimeframe('this-month')">Indeværende måned</btn>
    <btn @click.native="setTimeframe('one-month-forward')">+</btn>
    &nbsp;&nbsp;&nbsp;
    <btn @click.native="setTimeframe('one-week-back')">&mdash;</btn>
    <btn @click.native="setTimeframe('last-7-days')">Sidste 7 dage</btn>
    <btn @click.native="setTimeframe('last-14-days')">Sidste 14 dage</btn>
    <btn @click.native="setTimeframe('last-30-days')">Sidste 30 dage</btn>
    <btn @click.native="setTimeframe('last-90-days')">Sidste 90 dage</btn>
    <btn @click.native="setTimeframe('one-week-forward')">+</btn>

    <div class="checkbox">
      <input type="checkbox" v-model="filter_only_billable" id="kj12b3kj">
      <label for="kj12b3kj">Vis kun fakturérbare</label>
    </div>

    <span v-if="0 && is_user('wp')">cachefiltered_timelogs: {{cachefiltered_timelogs.length || all_timelogs_count }}</span>  

  </box>

  <box :label="filteredTimelogs.length+' timelogs - '+ getListedTimelogStats.hours_total.toFixed(2) +' timer'" v-if="filteredTimelogs.length">

    <div class="grid">
      <div class="col m25">

        <div class="chart-minitable">
          <peity :type="'pie'" :options="{ 'fill': pieChartColors, width:80, height:80,  'innerRadius': 0, 'radius': 40 }" :data="clientsPieData"></peity>
          <div class="title">Kunder</div>
          <div class="entry" v-for="(entry,i) in getListedTimelogStats.clients" v-if=" parseInt(entry.value/getListedTimelogStats.hours_total*100) > 0 ">
            <span class="colorcircle" :style="{'background-color':pieChartColors[i]}"></span>
            <span class="name" v-if="entry.client">
              <router-link class="textlink" :to="'/client/'+entry.key">{{entry.client.name}}</router-link>
            </span>
            <span class="pct">
              {{parseInt(entry.value/getListedTimelogStats.hours_total*100)}}%
            </span>
            <span class="hours">
              {{parseInt(entry.value)}} timer
            </span>
          </div>
        </div>

      </div>
      <div class="col m25">

        <div class="chart-minitable">
          <peity :type="'pie'" :options="{ 'fill': pieChartColors, width:80, height:80,  'innerRadius': 0, 'radius': 40 }" :data="projectsPieData"></peity>
          <div class="title">Opgaver</div>
          <div class="entry" v-for="(entry,i) in getListedTimelogStats.projects" v-if=" parseInt(entry.value/getListedTimelogStats.hours_total*100) > 0 ">
            <span class="colorcircle" :style="{'background-color':pieChartColors[i]}"></span>
            <span class="name">
              <router-link class="textlink" :to="'/project/'+entry.key">{{entry.project.name}}</router-link>
            </span>
            <span class="pct">
              {{parseInt(entry.value/getListedTimelogStats.hours_total*100)}}%
            </span>
            <span class="hours">
              {{parseInt(entry.value)}} timer
            </span>
          </div>
        </div>

      </div>
      <div class="col m25">

        <div class="chart-minitable">
          <peity :type="'pie'" :options="{ 'fill': pieChartColors, width:80, height:80,  'innerRadius': 0, 'radius': 40 }" :data="usersPieData"></peity>
          <div class="title">Brugere</div>
          <div class="entry" v-for="(entry,i) in getListedTimelogStats.users">
            <span class="colorcircle" :style="{'background-color':pieChartColors[i]}"></span>
            <span class="name">
              <template v-if="entry.user">{{entry.user.first_name||'?'}}</template>
            </span>
            <span class="pct">
              {{parseInt(entry.value/getListedTimelogStats.hours_total*100)}}%
            </span>
            <span class="hours">
              {{parseInt(entry.value)}} timer
            </span>
          </div>
        </div>

      </div>
      <div class="col m25">

        <div class="chart-minitable">
          <peity :type="'pie'" :options="{ 'fill': pieChartColors, width:80, height:80,  'innerRadius': 0, 'radius': 40 }" :data="worktypesPieData"></peity>
          <div class="title">Arbejdstype</div>
          <div class="entry" v-for="(entry,i) in getListedTimelogStats.worktypes">
            <span class="colorcircle" :style="{'background-color':pieChartColors[i]}"></span>
            <span class="name">
              {{translateWorktype(entry.key)}}
            </span>
            <span class="pct">
              {{parseInt(entry.value/getListedTimelogStats.hours_total*100)}}%
            </span>
            <span class="hours">
              {{parseInt(entry.value)}} timer
            </span>
          </div>
        </div>

      </div>
    </div>


  </box>

  


  <box v-if="filteredTimelogs.length">

    <div _style="overflow-x:auto;">

      <table class="table-timespan-dates">
        <thead>
          <tr>
          <th v-for="entry in timespanDates" :data-day="entry.dayno">
              <span class="l1">{{entry.date.format('ddd')}}</span>
              <span class="l2">{{entry.date.format('D/M')}}</span>
            </th> 
          </tr>
        </thead>
        <tbody>
          <tr>
            <td v-for="entry in timespanDates" :data-day="entry.dayno">
              <span class="l1">{{entry.hours_logged}}</span>
              <span class="l2">timer</span>
              <div class="bar" :style="barHeight( entry.hours_logged, maxHoursLoggedInTimeSpanDates )"></div>                            
            </td>
          </tr>
        </tbody>
      </table>

    </div>
    
  </box>


  <box v-if="filteredTimelogs.length < 100">

    <table class="table-a timelogs-table">
      <thead>
        <tr>
          <th></th>
          <th v-if="false">Bruger</th>
          <th>Dato</th>
          <th>Tid</th>
          <th>Opgave</th>
          <th>Type</th>
          <th>Note</th>
          <th></th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <template v-for="(timelog,i) in filteredTimelogs">
          <tr v-if="timelogListDateSpacerBoolean(filteredTimelogs,i)">
            <td colspan="9" class="timelog-date-spacer"> </td>
          </tr>
          <tr>
            <td>
              <avatar :text="timelog.user.email | milkinitials"></avatar>
            </td>
            <td v-if="false"><avatar :input="timelog.user"></avatar></td>
            <td v-if="false">
              <template v-if="timelog.user">{{timelog.user.first_name || '?'}}</template>
            </td>
            <td>
              {{ nicedate(timelog.date, 'ddd D/M-YY') | weekday1dk }}
            </td>
            <td>
              {{timelog.hours}} t
            </td>
            <td>
              <router-link class="textlink" :to="'/project/'+timelog.project_key" v-if="timelog.project">{{timelog.project.name}}</router-link>
              <br>
              <router-link class="textlink" :to="'/client/'+timelog.project.client_key" v-if="timelog.client">{{timelog.client.name}}</router-link>              
            </td>
            <td>
              {{timelog.worktype_translated}}
            </td>
            <td>
              {{timelog.title}}
            </td>
            <td>
              <div class="textlink" @click="editTimelog(timelog)">
                <svgicon icon="linearicons/pencil"></svgicon>
              </div>
            </td>
            <td>
              <div class="textlink" @click="delete_timelog(timelog)">
                <svgicon icon="linearicons/trash"></svgicon>
              </div>
            </td>
    			</tr>
        </template>
      </tbody>
		</table>

	</box>

  
  <btn @click.native="transferTimelogsModal=true" v-if="!transferTimelogsModal">Overfør tidslogs</btn>

  <btn @click.native="exportTimelogs()">Eksportér tidslogs</btn>

  <box label="Overfør tidslogs" v-if="transferTimelogsModal">

    <div class="grid">
      <div class="col m50">
    
        <label>Fra opgave:</label>
        <multiselect
          :options="projectSelectOptions"
          :value="multiSelectGetOption(projectSelectOptions,'value',transferTimelogsProjectA)"
          @select="multiSelectOnSelect('transferTimelogsProjectA',$event)"
          placeholder="Vælg..." label="label" track-by="value" select-label="" selected-label="" deselect-label="" :reset-after="false"
        />

      </div>
      <div class="col m50">
    
        <label>Til opgave:</label>
        <multiselect
          :options="projectSelectOptions"
          :value="multiSelectGetOption(projectSelectOptions,'value',transferTimelogsProjectB)"
          @select="multiSelectOnSelect('transferTimelogsProjectB',$event)"
          placeholder="Vælg..." label="label" track-by="value" select-label="" selected-label="" deselect-label="" :reset-after="false"
        />
        
      </div>
    </div>

    <br>
    
    <btn @click.native="transferTimelogs()" v-if="is_admin">Overfør tidslogs...</btn>
    <btn @click.native="transferTimelogsModal=false">Luk</btn>
  </box>

  <br v-for="i in 100">

  </div>
</template>

<script>
import fdb from '.././firebase_config.js';
import _ from 'lodash'
import moment from 'moment'
import auth from './../auth.js';
import helpers from '../helpers.js';
import mixins from '../mixins.js';
import Box from '.././components/Box'
import Btn from '.././components/Btn'
import Inputfield from '.././components/Inputfield'
import Pagination from '.././components/Pagination'
import Datatable from '.././components/Datatable'
import Avatar from '.././components/Avatar'
import Minipctbar from '.././components/Minipctbar'
import Minidonut from '.././components/Minidonut'
import Multiselect from 'vue-multiselect'
import './../components/generated_svg_icons/linearicons/trash'
import './../components/generated_svg_icons/linearicons/pencil'
import Peity from 'vue-peity'
import jsfiledownload from 'js-file-download'
export default {
  components: { Box, Inputfield, Btn, Avatar, Datatable, Pagination, Minipctbar, Minidonut, Multiselect, Peity },
  name: 'timelogs',
  mixins: [ mixins.db, mixins.generic ],
  data: function () {
    return {
      globals: this.$parent.globals,
      user: auth.getUser(),
      filter_date_from: undefined,
      filter_date_to: undefined,
      filter_user_key: undefined,
      filter_project_key: undefined,
      filter_client_key: undefined,
      editing_timelog_key: undefined,
      pieChartColors: globals.pieChartColors,
      
      transferTimelogsModal:false,
      transferTimelogsProjectA: undefined,
      transferTimelogsProjectB: undefined,
      filter_only_billable: false,

      blockFilterUpdates: false,

    }
  },
  computed:{


    all_timelogs_count(){ return this.$store.getters['timelogs/getAll'].length },

    filter_date_from_timestamp(){
      if( !this.filter_date_from ) return
      return moment(this.filter_date_from).unix()
    },

    filter_date_to_timestamp(){
      if( !this.filter_dateto ) return
      return moment(this.filter_dateto).unix()
    },

    users(){ return this.$store.state.firebase.users },
    clients(){ return this.$store.state.firebase.clients },
    projects(){ return this.$store.state.firebase.projects },


    userSelectOptions(){
      var options = []
      options.push({ value:undefined, label:'Alle' })
      var items = this.$store.state.firebase.users
      if( !items ) return options
      for( var key in items )  {
        if(key == '.key') continue // why, vuexfire?
        var user = items[key]
        user['.key'] = key
        if( !user.first_name ) continue
        var option = { value:user['.key'], label:user.first_name  }
        options.push(option)
      }
      return options
    },
    
    clientSelectOptions(){
      var options = []
      options.push({ value:undefined, label:'Alle' })      
      var items = this.$store.state.firebase.clients
      if( !items ) return options
      for( var key in items )  {
        if(key == '.key') continue // why, vuexfire?
        var client = items[key]
        client['.key'] = key
        if( !client.name ) continue
        var option = { value:client['.key'], label:client.name  }
        options.push(option)
      }
      return options
    },
    
    projectSelectOptions(){
      var options = []
      options.push({ value:undefined, label:'Alle' })
      
      if( !this.$store.state.firebase.clients ) return options
      
      var list = this.$store.state.firebase.projects      
      for( var project_key in list ) {
        if(project_key == '.key') continue // why, vuexfire?
        var project = list[project_key]
        project['.key'] = project_key

        if( !project.name ) continue
        if( this.filter_client_key && project.client_key != this.filter_client_key ) continue
        var option = { value:project['.key'], label:project.name  }
        options.push(option)
      }
      return options
    },


    filterClientSelectOptions(){
      var output = []
      for( var client_key in this.$store.state.firebase.clients ) {
        var client = this.$store.state.firebase.clients[client_key]
        var label = client.name
        //if(!project_key) continue
        //if(client_key=='.key') continue
        output.push({
          value: client_key,
          label: client.name,
        })
      }
      //console.log(output)
      //return [{label:'joe',value:123},{label:'joge',value:1523},{label:'jeoe',value:1323}]
      return output
    },

    cachefiltered_timelogs(){      
      var timelogs = []
      if(  this.filter_user_key && !this.filter_client_key && !this.filter_project_key ) timelogs = this.$store.getters['timelogs/get_cached'].user[this.filter_user_key]      
      if( !this.filter_user_key &&  this.filter_client_key && !this.filter_project_key ) timelogs = this.$store.getters['timelogs/get_cached'].client[this.filter_client_key]      
      if( !this.filter_user_key && !this.filter_client_key &&  this.filter_project_key ) timelogs = this.$store.getters['timelogs/get_cached'].project[this.filter_project_key]
      return timelogs
    },



    filteredTimelogs(){

      //if( this.blockFilterUpdates ) return []

      var cachefiltered_timelogs = this.cachefiltered_timelogs

      if(  this.filter_user_key && !this.filter_client_key && !this.filter_project_key ) var cached_timelogs = this.$store.getters['timelogs/get_cached'].user[this.filter_user_key]      
      if( !this.filter_user_key &&  this.filter_client_key && !this.filter_project_key ) var cached_timelogs = this.$store.getters['timelogs/get_cached'].client[this.filter_client_key]      
      if( !this.filter_user_key && !this.filter_client_key &&  this.filter_project_key ) var cached_timelogs = this.$store.getters['timelogs/get_cached'].project[this.filter_project_key]

      //if(  cachefiltered_timelogs.length ) this.toast('Filtering '+cachefiltered_timelogs.length+' timelogs...')
      //if( !cachefiltered_timelogs.length ) this.toast('Filtering '+this.all_timelogs_count+' timelogs...')

      if( !cachefiltered_timelogs.length ) cachefiltered_timelogs = undefined

      var timelogs = this.$store.getters['timelogs/getFiltered']({
        user_key:    this.filter_user_key,
        project_key: this.filter_project_key,
        client_key:  this.filter_client_key,
        date_from_timestamp:   this.filter_date_from_timestamp,
        date_to_timestamp:     this.filter_date_to_timestamp,
        only_billable: this.filter_only_billable,
        no_sorting: true,
      }, cachefiltered_timelogs )

      timelogs = this.$store.getters['timelogs/sort_newest'](timelogs)

      for( let timelog of timelogs ) {
        timelog.user = this.$store.getters.getOne('user', timelog.user_key)
        timelog.project = this.$store.getters.getOne('project', timelog.project_key)
        timelog.client = this.$store.getters.getOne('client', timelog.project.client_key)
        timelog.worktype_translated = this.translateWorktype(timelog.worktype)
      }

      return timelogs

    },
    


    getListedTimelogStats(){

      var output = {
        hours_total:0,
        clients: {},
        projects: {},
        users: {},
        worktypes: {},
      }
      var timelogs = this.filteredTimelogs
      for( let timelog of timelogs ){
        if( timelog.hours ) output.hours_total += parseFloat(timelog.hours)

        if ( output.clients[ timelog.client_key ] == undefined ) output.clients[ timelog.client.key ] = 0
        output.clients[ timelog.client.key ] += parseFloat(timelog.hours)

        if ( output.projects[ timelog.project_key ] == undefined ) output.projects[ timelog.project_key ] = 0
        output.projects[ timelog.project_key ] += parseFloat(timelog.hours)

        if ( output.users[ timelog.user_key ] == undefined ) output.users[ timelog.user_key ] = 0

        output.users[ timelog.user_key ] += parseFloat(timelog.hours)

        if ( output.worktypes[ timelog.worktype ] == undefined ) output.worktypes[ timelog.worktype ] = 0
        output.worktypes[ timelog.worktype ] += parseFloat(timelog.hours)
      }
      //output.projects = Array.from(output.projects)

      var temp = []
      for ( let key in output.clients ) temp.push({ client:this.getOne('client',key), value:output.clients[key] })
      temp.sort(function(a,b){ return ( b.value - a.value ) })
      output.clients = temp
      
      var temp = []
      for ( let key in output.projects ) temp.push({ project:this.getOne('project',key), value:output.projects[key] })
      temp.sort(function(a,b){ return ( b.value - a.value ) })
      output.projects = temp

      var temp = []
      for ( let key in output.users ) temp.push({ user:this.getOne('user',key), value:output.users[key] })
      temp.sort(function(a,b){ return ( b.value - a.value ) })
      output.users = temp

      var temp = []
      for ( let key in output.worktypes ) temp.push({ key:key, value:output.worktypes[key] })
      temp.sort(function(a,b){ return ( b.value - a.value ) })
      output.worktypes = temp

      //console.log(output)

      return output
    },

    clientsPieData() {
      var entries = this.getListedTimelogStats.clients
      var levels = _.map(entries, 'value')
      return levels.toString()
    },
    projectsPieData() {
      var entries = this.getListedTimelogStats.projects
      var levels = _.map(entries, 'value')
      return levels.toString()
    },
    usersPieData() {
      var entries = this.getListedTimelogStats.users
      var levels = _.map(entries, 'value')
      return levels.toString()
    },
    worktypesPieData() {
      var entries = this.getListedTimelogStats.worktypes
      var levels = _.map(entries, 'value')
      return levels.toString()
    },

    timespanDates(){
      
      if( !this.filteredTimelogs || this.filteredTimelogs.length > 500 ) return []
      
      var dates = helpers.moment_enumerateDaysBetweenDates( this.filter_date_from, moment(this.filter_date_to).add(1,'days') )
      var output = []

      console.log('timespanDates')

      //return output
      
      for( var i = 0; i < dates.length; i++ ) {
        var date = dates[i]

        var filters = {
          date_from_timestamp:   date.clone().add(-1,'days').unix(),
          date_to_timestamp:     date.clone().add(-1,'days').unix(),
        }

        var logs = this.$store.getters['timelogs/getFiltered'](filters, this.filteredTimelogs)
        var hours = this.$store.getters['timelogs/getTotalHours'](logs)
        
        output.push({
          date: date.utc(),
          hours_logged: hours,
          title: date.format('D/M'),
          dayno: date.day()
        })
      }

      return output
    },

    maxHoursLoggedInTimeSpanDates(){
      var o = 0
      
      for( var i = 0; i < this.timespanDates.length; i++ ) {
        var d = this.timespanDates[i]
        if( parseFloat(d.hours_logged) > o ) o = parseFloat(d.hours_logged)
      }

      return o
    },


  }, // computed

  methods: {

    filter_date_from_change(e){ this.filter_date_from = e.target.value },
    filter_date_to_change(e){ this.filter_date_to = e.target.value },


    barHeight( a,b ){
      var css = {}

      if( a == undefined || isNaN(a) ) a = 0
      if( b == undefined || isNaN(b) ) b = 0

      var pct = parseInt(( a/b ) * 100 )

      if( pct < 0 ) pct = 0
      if( pct > 100 ) pct = 100

      css.height = pct + '%'
      return css
    },

    //getUserbyUID: helpers.getUserbyUID,
    translateWorktype: helpers.translateWorktype,
    
    editTimelog(timelog){
      globals.modal_timelog_edit.timelog = timelog
      globals.modal_timelog_edit.active = true
    },

    multiSelectOnSelect(item_key,activeOption){
      var value = activeOption.value
      //console.log(item_key)
      //console.log(activeOption)      
      //console.log(value)
      //console.log(value)

      this.$set(this, item_key, value)

    },

    gotoClient(input){
      var a = 'client/', b
      if( typeof input == 'string' ) b = input
      if( typeof input != 'string' ) b = input['.key']
      this.$router.push(a+b)
    },

    gotoProject(input){
      var a = 'project/', b
      if( typeof input == 'string' ) b = input
      if( typeof input != 'string' ) b = input['.key']
      this.$router.push(a+b)
    },

    setTimeframe(timeframe){
      var from_date, to_date
      if( timeframe == 'today' ) {
        from_date = moment()
        to_date = moment()
      }
      if( timeframe == 'this-month' ) {
        from_date = moment().startOf('month')
        to_date = moment().endOf('month')
      }
      if( timeframe == 'last-7-days' ) {
        from_date = moment().subtract(7,'days')
        to_date = moment()
      }
      if( timeframe == 'last-14-days' ) {
        from_date = moment().subtract(14,'days')
        to_date = moment()
      }
      if( timeframe == 'last-30-days' ) {
        from_date = moment().subtract(30,'days')
        to_date = moment()
      }
      if( timeframe == 'last-90-days' ) {
        from_date = moment().subtract(90,'days')
        to_date = moment()
      }
      if( timeframe == 'one-day-back' ) {
        from_date = moment(this.filter_date_from).subtract(1,'days')
        to_date = moment(this.filter_date_to).subtract(1,'days')
      }
      if( timeframe == 'one-day-forward' ) {
        from_date = moment(this.filter_date_from).add(1,'days')
        to_date = moment(this.filter_date_to).add(1,'days')
      }
      if( timeframe == 'one-week-back' ) {
        from_date = moment(this.filter_date_from).subtract(1,'weeks')
        to_date = moment(this.filter_date_to).subtract(1,'weeks')
      }
      if( timeframe == 'one-week-forward' ) {
        from_date = moment(this.filter_date_from).add(1,'weeks')
        to_date = moment(this.filter_date_to).add(1,'weeks')
      }
      if( timeframe == 'one-month-back' ) {
        from_date = moment(this.filter_date_from).subtract(1,'months')
        to_date = moment(this.filter_date_to).subtract(1,'months')
        if( from_date.date() == 1 ) to_date = to_date.endOf('month')
      }
      if( timeframe == 'one-month-forward' ) {
        from_date = moment(this.filter_date_from).add(1,'months')
        to_date = moment(this.filter_date_to).add(1,'months')
        if( from_date.date() == 1 ) to_date = to_date.endOf('month')
      }
      this.filter_date_from = from_date.format('YYYY-MM-DD')
      this.filter_date_to = to_date.format('YYYY-MM-DD')
    },

    nicedate(date, format){
      if( !format ) format = 'YYYY-MM-DD'
      return moment(date).format(format)
    },

    
    delete_timelog: helpers.delete_timelog,
	  roundToDecs: helpers.roundToDecs,

    openTimelogger(){ eventBus.$emit('openTimelogger') },

    timelogListDateSpacerBoolean(filteredTimelogs,i){
      if(i==0) return false
      var timelog = filteredTimelogs[i]
      var timelog_prev = filteredTimelogs[i-1]
      return (timelog.date != timelog_prev.date)
    },

    dateFormat( date, format ){
      return moment( date ).format(format)
    },

    multiSelectGetOption(options,key,val){
			if( !options ) return
			for( let option of options ) if( option[key] == val ) return option			
		},


    transferTimelogs()
    {

      var input = {
        project_a: this.transferTimelogsProjectA,
        project_b: this.transferTimelogsProjectB,
      }

      if( input.project_a == input.project_b ) {
        eventBus.$emit('toast', {text: 'Vælg to forskellige opgaver...'})
        return false
      }
      
      var confirmed = confirm('Dette vil øverføre ALLE tidsloggings fra '+getOne(input.project_a).name+' til '+getOne(input.project_b).name+'. Dette vil IKKE kunne fortrydes. Er du sikker?')
			if( !confirmed ) return

      var updated_count = 0

      var list = this.$store.state.firebase.timelogs      
      for( var timelog_key in list ) {
        if(timelog_key == '.key') continue // why, vuexfire?
        var timelog = list[timelog_key]
        
        if( timelog.project_key == input.project_a ) {
          fdb.ref('timelogs').child(timelog_key).update({ project_key: input.project_b })
          updated_count++
        }

      }
      
      eventBus.$emit('toast', {text: updated_count + ' timelogs overført'})
      
    },

    exportTimelogs(){
      var logs = this.filteredTimelogs
      
      var o = 'Dato,Arbejdstimer,Navn,Tekst' + "\r\n"
      for( var i = 0; i < logs.length; i++ ) {
        var log = logs[i]
        var user = this.getOne('user',log.user_key)
        o += log.date + ','
        o += log.hours + ','
        o += user.first_name + ','
        o += '"'+( log.title || '' )+'"'
        o += "\r\n"
      }
      o += "\r\n"
      o += this.filteredTimelogs.length + ' timelogs,'
      o += this.getListedTimelogStats.hours_total + ' arbejdstimer'

      var d1 = this.dateFormat(this.filter_date_from,'DD-MM-YY')
      var d2 = this.dateFormat(this.filter_date_to,'DD-MM-YY')
      
      var filename = 'Milk Studio - Timelogs '+d1+' - '+d2+'.csv'
      
      jsfiledownload(o, filename)

    },

  },//methods

  created(){

    this.filter_date_from = moment().subtract(1,'week').format('YYYY-MM-DD')
    this.filter_date_to = moment().format('YYYY-MM-DD')

    if( this.$route.params.user != 'any' )      this.filter_user_key = this.$route.params.user
    if( this.$route.params.client != 'any' )    this.filter_client_key = this.$route.params.client
    if( this.$route.params.project != 'any' )   this.filter_project_key = this.$route.params.project
    if( this.$route.params.from_date != 'any' ) this.filter_from_date = this.$route.params.from_date
    if( this.$route.params.to_date != 'any' )   this.filter_to_date = this.$route.params.to_date

  },

}
</script>



// WEBPACK FOOTER //
// Timelogs.vue?7463fde6